export const selectors = {
    searchForm: '#funding-decisions-search-form',
    searchInput: '.js-funding-search-input',
    searchButton: '.js-search-button',
    clearSearchButton: '.js-clear-search',
    yearSelect: '.js-funding-year-select',
    fundingTypeSelect: '.js-funding-type-select',
    resultsContainer: '.js-funding-results-body',
    expandFilterButton: '.js-expand-filter',
    expandableFilter: '.js-expandable-filter-wrapper',
    clearAllButton: '.js-clear-all',
    noResultsContainer: '.js-no-results',
    loadingSkeletons: '.js-funding-skeletons'
};

const searchForm = document.querySelector(selectors.searchForm);

export const elements = {
    searchForm,
    searchInput: searchForm?.querySelector(selectors.searchInput),
    searchButton: searchForm?.querySelector(selectors.searchButton),
    clearSearchButton: searchForm?.querySelector(selectors.clearSearchButton),
    yearSelect: searchForm?.querySelector(selectors.yearSelect),
    fundingTypeSelect: searchForm?.querySelector(selectors.fundingTypeSelect),
    resultsContainer: document.querySelector(selectors.resultsContainer),
    expandFilterButton: searchForm?.querySelector(selectors.expandFilterButton),
    expandableFilter: searchForm?.querySelector(selectors.expandableFilter),
    clearAllButton: searchForm?.querySelector(selectors.clearAllButton),
    noResultsContainer: document.querySelector(selectors.noResultsContainer),
    loadingSkeletons: document.querySelector(selectors.loadingSkeletons),
};
